import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/i18n';
import '@/theme/global.css';
import { aplicaTema } from '@/theme/theme';
import App from './App';

aplicaTema();

const arrel = document.getElementById('root');
if (arrel) {
  createRoot(arrel).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
